/*eslint-disable*/
import React, { useContext, useEffect, useState } from "react";
// @material-ui/core components
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
// core components
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";

import { eventPageStyles } from "./styles";
// nodejs library that concatenates classes
import classNames from "classnames";

import SportappHeader from "customComponents/SportappHeader/Header";
import Table from "components/Table/Table";
import ClubLogoImg from "customComponents/ClubLogoImg/ClubLogoImg.js";
import { Link, useParams } from "react-router-dom";
import {
	getAgeGroupToDisplay,
	getSchedulesToDisplay,
	mapDayEnumsToFullName,
} from "utils/Utils.js";
import Button from "components/CustomButtons/Button";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { observer } from "mobx-react";
import { RootStoreContext } from "mobX/RootStore.js";
import backgroundImage from "customAssets/img/ssb_background.png";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import CardFooter from "../../components/Card/CardFooter";

const EventDetails = observer(() => {
	const store = useContext(RootStoreContext);
	const eventStore = store.eventStore;

	let { eventName } = useParams();
	const [event, setEvent] = useState({ image: null });
	const [backgroundImageURI, setBackgroundImageURI] = useState(backgroundImage);

	useEffect(() => {
		eventStore.fetchEvents();
	}, []);

	useEffect(() => {
		if (!eventStore.isLoading) {
			const event = eventStore.getEventByName(eventName);
			if (event) {
				setEvent(event);
			}
		}
	}, [eventStore.isLoading]);

	useEffect(() => {
		if (event.image) setBackgroundImageURI(event.image);
	}, [event.image]);

	const coursesForDay = (courses, day) => {
		return courses.filter((course) =>
			course.schedule.schedules.some((schedule) => schedule.day === day),
		);
	};

	React.useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
	});
	const classes = eventPageStyles();

	const imageClasses = classNames(
		classes.eventClubLogo,
		classes.imgRaised,
		classes.imgRoundedCircle,
		classes.imgFluid,
	);
	return (
		<div>
			<SportappHeader />

			<Parallax image={backgroundImageURI} filter="dark" small>
				{event && event.club && (
					<div className={classes.container}>
						<GridContainer
							justifyContent="center"
							className={classes.parallaxTitle}
						>
							<GridItem xs={4} sm={4} md={2} className={classes.titleClubLogo}>
								<ClubLogoImg
									clubLogo={event.club.logo}
									alt={event.club.name}
									imgClasses={imageClasses}
								/>
							</GridItem>
							<GridItem xs={12} sm={8} md={8} className={classes.textCenter}>
								<h1 className={classes.title}>{event.name}</h1>
								<h4 className={classes.title}>
									Veranstalter: {event.club.name}
								</h4>
								<h3 className={classes.title}>
									{new Date(event.schedule.from).toLocaleDateString()} -{" "}
									{new Date(event.schedule.to).toLocaleDateString()}
								</h3>
							</GridItem>
						</GridContainer>
					</div>
				)}
			</Parallax>
			{event && (
				<div className={classes.main}>
					<GridContainer justifyContent="center">
						<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
							<div className={classNames(classes.container, classes.section)}>
								<h3 className={classes.tagline}>{event.tagline}</h3>
								<div
									dangerouslySetInnerHTML={{ __html: event.descriptionAsHtml }}
								/>
							</div>
						</GridItem>
						<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
							<div>
								<div className={classes.details}>{event.details}</div>
							</div>
						</GridItem>
						{[
							"MONDAY",
							"TUESDAY",
							"WEDNESDAY",
							"THURSDAY",
							"FRIDAY",
							"SATURDAY",
							"SUNDAY",
						].map((day) => {
							const courses = event.courses
								? coursesForDay(event.courses, day)
								: [];

							if (courses.length > 0)
								return (
									<GridItem
										xs={10}
										sm={10}
										md={8}
										className={classes.textCenter}
										key={day}
									>
										<h3 className={classes.weekdayHeader}>
											Jeden {mapDayEnumsToFullName(day)}
										</h3>

										<Table
											striped
											tableData={courses.map((course, index) => {
												return [
													<ClubLogoImg
														key={`nextButton-${index}`}
														clubLogo={course.club.logo}
														alt={course.club.name}
														imgClasses={classes.img}
													/>,
													course.title,
													course.schedule.schedules
														? getSchedulesToDisplay(course.schedule.schedules)
														: "-",
													course.targetGroup
														? getAgeGroupToDisplay(course.targetGroup)
														: "-",
													<Link
														key={`nextButton-${index}`}
														to={`/course/${encodeURIComponent(
															course.title,
														)}?id=${course.id}`}
													>
														<Button
															color="primary"
															className={classes.detailsButton}
														>
															<ArrowForwardIcon />
														</Button>
													</Link>,
												];
											})}
											customCellClasses={[
												classes.clubIcon,
												classes.activityTitle,
												classes.schedule,
												classes.targetGroup,
												classes.detailsButton,
											]}
											customClassesForCells={[0, 1, 2, 3, 4]}
										/>
									</GridItem>
								);
						})}
						{event.sponsors && event.sponsors.length > 0 && (
							<GridContainer className={classes.sponsorWrapper}>
								<GridItem
									xs={12}
									sm={12}
									md={12}
									className={classes.textCenter}
								>
									<h4>
										<strong>{event.name}</strong> wird unterstützt von
									</h4>
								</GridItem>

								{event.sponsors.map((sponsor) => (
									<GridItem xs={12} sm={4} key={sponsor.name}>
										<Card profile>
											<CardHeader image>
												<a
													href={sponsor.url}
													onClick={(e) => e.preventDefault()}
												>
													<img src={sponsor.logo} alt={sponsor.name} />
												</a>
												<div
													className={classes.coloredShadow}
													style={{
														backgroundImage: `url(${sponsor.logo})`,
														opacity: "1",
													}}
												/>
											</CardHeader>
											<CardBody>
												<h4 className={classes.cardTitle}>{sponsor.name}</h4>
											</CardBody>
											<CardFooter
												profile
												className={classes.justifyContentCenter}
											>
												<Button round color="info" href={sponsor.url}>
													{sponsor.callToAction}
												</Button>
											</CardFooter>
										</Card>
									</GridItem>
								))}
							</GridContainer>
						)}
					</GridContainer>
				</div>
			)}
			<Footer
				content={
					<div>
						<div className={classes.left}>
							<List className={classes.list}>
								<ListItem className={classes.inlineBlock}>
									<a href="/impressum/" className={classes.block}>
										Impressum
									</a>
								</ListItem>
								<ListItem className={classes.inlineBlock}>
									<a href="/datenschutz/" className={classes.block}>
										Datenschutzerklärung
									</a>
								</ListItem>
							</List>
						</div>
						<div className={classes.right}>
							&copy; {1900 + new Date().getYear()} Solinger Sportbund e.V.
						</div>
					</div>
				}
			/>
		</div>
	);
});

export default EventDetails;
